import { AppRole } from './useRole'

// The marketing role only sees agencies whose name contains one of these (case-insensitive).
const MARKETING_AGENCY_KEYWORDS = ['google', 'instagram'] as const

const MARKETING_AGENCY_OR_FILTER = MARKETING_AGENCY_KEYWORDS.map(
  (keyword) => `agency.ilike.%${keyword}%`
).join(',')
/**
 * Returns the PostgREST `or` clause that scopes visitor queries by role.
 * Marketing users only see google/instagram agencies; other roles see everything.
 * Pass the result to `useGetVisitors({ orFilter })`.
 */

export const getAgencyScopeOrFilter = (role: AppRole | null): string | undefined =>
  role === 'marketing' ? MARKETING_AGENCY_OR_FILTER : undefined
